<template>
  <div class="pb-10">
    <!-- @slot overrides the default h4 title display -->
    <slot name="title">
      <h4>{{ title }}</h4>
    </slot>

    <v-divider class="mb-6"/>

    <p v-if="intro" class="pb-3">{{ intro }}</p>

    <!-- @slot the content of the profile block -->
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'FinMyProfileBlock',
  props: {
    /** The title of the my profile block */
    title: {
      type: String
    },
    /** The intro text, displayed beneath the divider and before the default slot content */
    intro: {
      type: String
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
